import React, { Component } from 'react';
import './EditorWrapper.css';
import EditorContainer from '../editor-container/EditorContainer';

class EditorWrapper extends Component {
  render() {
    const { lang } = this.props;
    return (
      <div className="BookDesigner_ContentArea">
        <EditorContainer lang={lang} />
      </div>
    );
  }
}

export default EditorWrapper;




// WEBPACK FOOTER //
// ./src/components/editor-wrapper/EditorWrapper.jsx